export default "<p>test-component works! all kinds of things</p>\r\n\r\n"